export const converteData = (data) => {
  if (!data) {
    return;
  }

  let date = "";
  let regexp = /\d\d\/\d\d\/\d\d\d\d\b/;

  if (data) {
    if (typeof data === "object") {
      data = data.toString();
    }

    if (data.match(regexp)) {
      let dataArray = data.split("/");
      let dataFormatada =
        dataArray[2] + "-" + dataArray[1] + "-" + dataArray[0] + "T00:00:00";
      date = new Date(dataFormatada);
    } else {
      data = new Date(data);

      let dia = data.getDate().toString();
      let mes = (data.getMonth() + 1).toString();
      let ano = data.getFullYear().toString();

      if (dia.length < 2) {
        dia = "0" + dia;
      }
      if (mes.length < 2) {
        mes = "0" + mes;
      }

      date = dia + "/" + mes + "/" + ano;
    }
    return date;
  }
};
